/**
 * タイムラインの始点の基準値（px）
 */
export const PerOneHour = 70;
/**
 * タイムラインの始点の基準値（px）
 */
export const StartPointPerOneMinutes = 1;

/**
 * 高さの基準値（px）
 */
export const HeightPerOneMinutes = 1;

/**
 * 幅の基準値（px）
 */
export const WidthPerOnePanel = 80;

/**
 * 重複時の調整値（左への移動量）
 */
export const LeftOffset = 100;

/**
 * パネル上端のオフセット（px）
 */
export const PanelTopOffset = 10;

/**
 * パネル左端のベースオフセット（px）
 */
export const PanelLeftBaseOffset = 47;

/**
 * パネル幅（px）
 */
export const PanelWidth = 112;

/**
 * タイムラインのパネル領域の既定最小幅（px）。
 */
export const TimelineDefaultMinWidth = 1080;

export const TimeList = [
	{ id: 0, time: "00:00" },
	{ id: 1, time: "01:00" },
	{ id: 2, time: "02:00" },
	{ id: 3, time: "03:00" },
	{ id: 4, time: "04:00" },
	{ id: 5, time: "05:00" },
	{ id: 6, time: "06:00" },
	{ id: 7, time: "07:00" },
	{ id: 8, time: "08:00" },
	{ id: 9, time: "09:00" },
	{ id: 10, time: "10:00" },
	{ id: 11, time: "11:00" },
	{ id: 12, time: "12:00" },
	{ id: 13, time: "13:00" },
	{ id: 14, time: "14:00" },
	{ id: 15, time: "15:00" },
	{ id: 16, time: "16:00" },
	{ id: 17, time: "17:00" },
	{ id: 18, time: "18:00" },
	{ id: 19, time: "19:00" },
	{ id: 20, time: "20:00" },
	{ id: 21, time: "21:00" },
	{ id: 22, time: "22:00" },
	{ id: 23, time: "23:00" },
	{ id: 24, time: "24:00" },
] as const;

export const HourList = [
	{ hour: 0 },
	{ hour: 1 },
	{ hour: 2 },
	{ hour: 3 },
	{ hour: 4 },
	{ hour: 5 },
	{ hour: 6 },
	{ hour: 7 },
	{ hour: 8 },
	{ hour: 9 },
	{ hour: 10 },
	{ hour: 11 },
	{ hour: 12 },
	{ hour: 13 },
	{ hour: 14 },
	{ hour: 15 },
	{ hour: 16 },
	{ hour: 17 },
	{ hour: 18 },
	{ hour: 19 },
	{ hour: 20 },
	{ hour: 21 },
	{ hour: 22 },
	{ hour: 23 },
] as const;
